"use client"
import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../lib/commonCSSProps"
import { AutoSliderProps, RenderConfig } from "./RenderConfig"

export const AutoSlider: ComponentConfig<AutoSliderProps> = {
  label: "Auto Slider",
  //@ts-ignore
  fields: {
    cardType: {
      label: "Card Type",
      type: "select",
      options: [
        { label: "Testimonial", value: "testimonial" },
        { label: "Image Only", value: "image" },
      ],
    },
    slides: {
      label: "Slides",
      type: "array",
      getItemSummary: (slides, index = 0) => `Slide: ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        url: {
          label: "Link",
          type: "text",
        },
        description: {
          label: "Description",
          type: "textarea",
        },
        name: {
          label: "Name",
          type: "text",
        },
        position: {
          label: "Position",
          type: "text",
        },
        avatar: {
          label: "Avatar Image",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
      },
    },
    spaceBetween: {
      label: "Space Between Slides (px)",
      type: "number",
      min: 0,
    },
    slidesPerView: {
      label: "Slides Per View (Desktop)",
      type: "number",
      min: 1,
    },
    slidesPerViewMobile: {
      label: "Slides Per View (Mobile)",
      type: "number",
      min: 1,
    },
    spaceBetweenMobile: {
      label: "Space Between Slides (Mobile)",
      type: "number",
      min: 0,
    },
    loop: {
      label: "Loop",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    speed: {
      label: "Speed (ms)",
      type: "number",
      min: 0,
    },

    ...commonStylesProps,
  },
  defaultProps: {
    cardType: "testimonial",
    slides: [
      {
        id: 1,
        url: "",
        description:
          "Cám ơn các bạn đã hỗ trợ từ việc xây dựng website, hệ thống quản trị nội bộ đến bảo trì hệ thống. Nhờ các bạn mà chúng tôi không phải lo về công nghệ, có thời gian tập trung vào việc phát triển business và chi nhánh.",
        name: "Mr. Đăng Thiện",
        position: "CEO of Fastcare",
        avatar: "",
      },
      {
        id: 2,
        url: "",
        description:
          "Cám ơn các bạn đã hỗ trợ từ việc xây dựng website, hệ thống quản trị nội bộ đến bảo trì hệ thống. Nhờ các bạn mà chúng tôi không phải lo về công nghệ, có thời gian tập trung vào việc phát triển business và chi nhánh.",
        name: "Mr. Đăng Thiện",
        position: "CEO of Fastcare",
        avatar: "",
      },
    ],
    spaceBetween: 36,
    slidesPerView: 3,
    slidesPerViewMobile: 1,
    speed: 3000,
    spaceBetweenMobile: 0,
    loop: true,
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
  },
  ...RenderConfig,
}
